function mainMenu() {

    // --------------------------  Mobile Menu
    const elHamburger = document.getElementById("hamburger");
    const elMobileMenu = document.querySelector(".mobile-menu");

    const mobileMenuToggle = () => {
        elHamburger.classList.toggle("opened");
        elMobileMenu.classList.toggle("opened");
    }

    elHamburger.onclick = () => {
        mobileMenuToggle()
    }




    // --------------------------  Mobile Sub Menus open
    const elButtonsMenu = document.getElementsByClassName('dropdown-toggle');

    Array.from(elButtonsMenu).forEach(function(element) {
        element.addEventListener('click', function () {
            this.parentElement.classList.toggle('opened');
        });
    });


    //
    //
    // // --------------------------  Desktop Dropdown menu open
    // const elDropdownMaster = document.getElementsByClassName('has-dropdown-menu')
    //
    // Array.from(elDropdownMaster).forEach(function(element) {
    //     element.addEventListener('mouseenter', function () {
    //         this.classList.add('dropdown--opened');
    //     });
    // });
    //
    // Array.from(elDropdownMaster).forEach(function(element) {
    //     element.addEventListener('mouseleave', function () {
    //         this.classList.remove('dropdown--opened');
    //     });
    // });

}

module.exports = {mainMenu}
